export default {
  methods: {
    downloadExcelTemplate(file) {
      window.open(`templates/${file}`, '_blank');
    },
  }
}
